export default __webpack_public_path__ + "static/stats-d29b9a806d6cb8f26b00e10f1eb3250c.svg";